import { TemplateRef, Directive } from "@angular/core";

@Directive({
    selector: 'ng-template[tcmTaxContent]',
    standalone: false
})
export class TcmTaxContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

